/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { LambdaTypeEnum } from './lambdaTypeEnum';


export interface DeploymentsCapabilitySpec { 
    /**
     * AWS account to use for binaries for creation and upgrade of deployment
     */
    account?: DeploymentsCapabilitySpec.AccountEnum;
    /**
     * Allow Deployment Spec to specify any release in Available/Default for deployment
     */
    allow_any_version?: boolean;
    /**
     * Allow deployment deactivation to skip deleting resources in shadow account.
     */
    allow_deactivation_without_cleanup?: boolean;
    /**
     * Allow import of deployments into service plane
     */
    allow_import?: boolean;
    /**
     * Allow deployments of multiple services in one org
     */
    allow_multi_service_in_org?: boolean;
    /**
     * Allow deployments of multiple services in org and given region
     */
    allow_multi_service_in_org_region?: boolean;
    /**
     * Allow deployment reactivation.
     */
    allow_reactivation?: boolean;
    /**
     * Allow region linking and unlinking using tenant self service APIs.
     */
    allow_self_service_linking?: boolean;
    /**
     * Allow tenant to reconfigure IRR.
     */
    allow_tenant_reconfigure?: boolean;
    /**
     * List of all AWS regions supported for deployment
     */
    aws_regions?: string;
    /**
     * List of all EVS regions supported for deployment
     */
    evs_regions?: string;
    /**
     * Allow activation only if an org has active commits.
     */
    commits_required?: boolean;
    /**
     * Deactivation Mode
     */
    deactivation_mode?: DeploymentsCapabilitySpec.DeactivationModeEnum;
    /**
     * Allow parallel activation in org
     */
    degree_of_parallelism?: number;
    /**
     * Enforce Org Owner Authorization for tenant deployments (to create Seed OAuth)
     */
    enforce_seed_oauth?: boolean;
    /**
     * Enable multiple SDDC providers for an org
     */
    enable_multiple_sddc_providers?: boolean;
    /**
     * List of all GCP regions supported for deployment
     */
    gcp_regions?: string;
    lambda?: LambdaTypeEnum;
    /**
     * Comma separated allowed deployment types for monitoring. Deployment types for monitoring are GCP, AWS.
     */
    monitoring_enabled_for?: string;
    /**
     * Allow Seed OAuth App credentials to be saved in Admin Account
     */
    save_seed_oauth_credentials_to_admin_account?: boolean;
    /**
     * Enable new scheme FQDN for VCDR. Note - This is applicable for VCDR service type only. Setting this value false for VMCFS will have no impact since we always use new FQDN scheme for VMCFS service type.
     */
    support_new_fqdn_scheme?: boolean;
    /**
     * List of all cloud providers supported for deployment
     */
    supported_cloud_provider?: string;
}
export namespace DeploymentsCapabilitySpec {
    export type AccountEnum = 'RELEASE' | 'SHADOW';
    export const AccountEnum = {
        RELEASE: 'RELEASE' as AccountEnum,
        SHADOW: 'SHADOW' as AccountEnum
    };
    export type DeactivationModeEnum = 'APPROVAL_REQUIRED' | 'APPROVAL_NOT_REQUIRED';
    export const DeactivationModeEnum = {
        APPROVAL_REQUIRED: 'APPROVAL_REQUIRED' as DeactivationModeEnum,
        APPROVAL_NOT_REQUIRED: 'APPROVAL_NOT_REQUIRED' as DeactivationModeEnum
    };
}


